 <!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-8">
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
              [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <div class="searchbox card fix lt" *ngIf="userRequestModel.isAdvanceSearch">
            <div class="form-row mb-3">
              <div class="col-md-4">
                <label for="role"><span translate>lblRole</span></label>
                <div class="lbl-info">
                  <select (change)="onRoleChange($event.target.value)"
                    [(ngModel)]="userRequestModel.roleId" class="custom-select custom-select mb-2">
                    <option value="" translate>lblSelectRole</option>
                    <option *ngFor="let role of roleList" [ngValue]="role.id">
                      {{role.roleName}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <label for="status"><span translate>lblStatus</span></label>
                <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
                  (change)="StatusChange($event,true)">
                  <ng-option *ngFor="let status of StatusList" [value]="status.id">
                    {{status.value}}
                  </ng-option>
                </ng-select>
              </div>
                <div class='col-md-4' *ngIf="dealerList && dealerList.length > 0">
                  <label translate>lblDefaultDealer</label>
                  <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="defaultDealerSelected"
                      ngDefaultControl name="advanceDealerDropdown" [selectedDealer]="defaultDealerId"
                      (onSelectDealer)="onDefaultDealerSelected($event)"
                      placeholder="Search Dealer">
                  </app-dealer-searchbox-dropdown>
              </div>
            </div>
            <div class="form-row mb-3">
              <div class="col-md-4">
                <label for="template-email"><span translate>lblEmail</span></label>
                <div class="lbl-info">
                  <input id="template-email" name="email" maxlength="50" [(ngModel)]="userRequestModel.email"
                    placeholder="{{ 'lblEnterEmailId' | translate }}" class="form-control mb-2">
                </div>
              </div>
              <div class="col-md-4">
                <label for="template-mobile"><span translate>lblMobile</span></label>
                <div class="lbl-info">
                  <input id="mobile" name="mobile" maxlength="15" [(ngModel)]="userRequestModel.mobile"
                    placeholder="{{ 'lblEnterMobileNumber' | translate }}" class="form-control mb-2">
                </div>
              </div>
              <div class="col-md-4">
                <label for="locationCode"><span translate>lblLocationCode</span></label>
                <div class="lbl-info">
                  <input id="locationCode" name="locationcode" maxlength="50"
                    placeholder="{{ 'lblEnterLocationCode' | translate }}" [(ngModel)]="userRequestModel.locationCode"
                    class="form-control mb-2">
                </div>
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col text-right">
                <button type="submit" (click)="AdvanceSearchSubmit()" class="btn btn-primary mr-sm-2" translate>lblApply
                </button>
                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-3" translate>lblReset
                </button>
                <button (click)="onClose()" class="btn btn-outline-tertiary" translate>lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="dealerList && dealerList.length > 0">
      <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="dealerSelected" ngDefaultControl
        name="advanceDealerDropdown" [selectedDealer]="dealerId" (onSelectDealer)="onDealerSelected($event)"
        placeholder="Search Dealer">
      </app-dealer-searchbox-dropdown>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
      <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
        (change)="StatusChange($event,false)">
        <ng-option *ngFor="let status of StatusList" [value]="status.id">
          {{status.value}}
        </ng-option>
      </ng-select>
    </div>
    <div class="col-auto ml-auto">
      <button type="button" (click)="exportAsXLSX(documentTypes.Excel)" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
        aria-label="Center Align">
        <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
      </button>
      <button class="ml-2 btn btn-link icon-pdf" type="button" (click)="onDownloadPDF(documentTypes.Pdf)"
        ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
        <em class="far fa-file fa-2x"></em>
        <span class="bdg">PDF</span>
      </button>
      <button type="button" (click)="onAdd()" *ngIf="userRoleRightsDetails.canAdd" aria-label="Center Align" type="reset"
        class="add-button btn btn-primary ml-2" translate>lblAddUser</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblUsers</h4>
        </div>
        <div class="table-responsive">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 20%" scope="col" sortable="name" (sort)="onSort($event)"><span
                    translate>lblName</span></th>
                <th style="width: 20%" scope="col" translate>lblRole</th>
                <th style="width: 20%" scope="col" translate>lblDealer</th>
                <th style="width: 20%" scope="col" translate>lblDefaultDealer</th>
                <th style="width: 15%" scope="col" translate>lblADEmail</th>
                <th style="width: 20%" scope="col" translate>lblMobile</th>
                <th style="width: 22%" scope="col" *ngIf="!areCodesHidden" translate>lblDealershipsId</th>
                <th style="width: 22%" scope="col" *ngIf="!areCodesHidden" translate>lblFunctionCode</th>
                <th style="width: 20%" class="text-center" scope="col" sortable="isActive" (sort)="onSort($event)"
                  translate>lblActive</th>
                <th style="width: 120px" class="text-center" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="userList?.length>0; else load_else">
                <tr *ngFor="let user of userList; let i=index">
                  <td>{{user.rowNumber}}</td>
                  <td>
                    <ngb-highlight [result]="user.userName" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="user.roleName" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="user.dealerName" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="user.defaultDealerName" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="user.email" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td>
                    <span *ngIf="user && user.mobileCode"> +{{user.mobileCode}}-</span>
                    <ngb-highlight [result]="user.mobile?user.mobile:''" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td *ngIf="!areCodesHidden">
                    <span *ngIf="user.locationCode">{{user.locationCode}} - {{user.locationName}}</span>
                  </td>
                  <td *ngIf="!areCodesHidden">
                    <span *ngIf="user.functionCode">{{user.functionCode}} - {{user.functionCodeDescription}}</span>
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check" *ngIf="user.isActive === true"></em>
                    <em class="fas fa-close" *ngIf="user.isActive === false"></em>
                  </td>
                  <td class="nowrap text-center">

                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canEdit && user.isEditable; else disabledView"
                      (click)="editUser(user)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <ng-template #disabledView>
                      <a class="btn btn-ico disabled" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert">
                        <em class="fas fa-pencil-alt fa-lg"></em>
                      </a>
                    </ng-template>
                    <span class="ico-div"></span>
                    <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canDelete && user.isEditable ; else disabledDeleteView"
                      (click)="deleteUser(user.userId)">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>
                    <ng-template #disabledDeleteView>
                      <a class="btn btn-ico disabled" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert">
                        <em class="far fa-trash-alt fa-lg"></em>
                      </a>
                    </ng-template>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>No Records Found</td>
                </tr>
              </ng-template>
            </tbody>
          </table>

        </div>

        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
  <table style="display: none;" class="table" id="userPdf">
    <thead>
      <tr>
        <th style="width: 55px" scope="col">#</th>
        <th style="width: 20%" scope="col"><span translate>lblName</span></th>
        <th style="width: 10%" scope="col" translate>lblRole</th>
        <th style="width: 20%" scope="col" translate>lblDealer</th>
        <th style="width: 20%" scope="col" translate>lblEmail</th>
        <th style="width: 20%" scope="col" translate>lblMobile</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="userListPdf?.length>0; else load_else">
        <tr *ngFor="let user of userListPdf; let i=index">
          <td>{{user.no}}</td>
          <td>
            <ngb-highlight [result]="user.userName"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.roleName"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.dealerName"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.email">
            </ngb-highlight>
          </td>
          <td>
            <span *ngIf="user && user.mobileCode"> +{{user.mobileCode}}-</span>
            <ngb-highlight [result]="user.mobile?user.mobile:''">
            </ngb-highlight>
          </td>
        </tr>
      </ng-container>
      <ng-template #load_else>
        <tr>
          <td colspan="8" class="no-record" translate>No Records Found</td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>
<!-- new theme implementation ends -->